import React from "react";
import { Row, Col, Avatar } from "antd";
import { UserOutlined } from "@ant-design/icons";

const dateFormat = "DD-MM-YYYY hh:mm a";

const Comment = ({ date, src = "", fullName, position = "", comment = "" }) => {
  return (
    <Row
      style={{
        background: "rgba(170, 169, 169, 0.1)",
        borderRadius: 10,
        padding: 10,
      }}
    >
      <Col span={1}>
        <Avatar
          size={24}
          src={src}
          icon={<UserOutlined />}
          style={{ marginTop: 2 }}
        />
      </Col>
      <Col span={23}>
        <div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              fontSize: 12,
            }}
          >
            <span style={{ color: "#202020", fontWeight: "bold" }}>
              {fullName}{" "}
              <span style={{ marginLeft: 5, color: "#808080" }}>
                {position}
              </span>{" "}
            </span>
            <span>
              {moment(date, "YYYY-MM-DD hh:mm:ss Z").format(dateFormat)}
            </span>
          </div>
          <div style={{ color: "#000", fontSize: 13 }}>{comment}</div>
        </div>
      </Col>
    </Row>
  );
};

export default Comment;
